/**
 * @generated SignedSource<<3e68e07f5b5364e7fba2d2b3029d6b81>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ParticipantsTable_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AlertVoxpopmeVideoAnalysis_user" | "ParticipantBatchActions_user">;
  readonly " $fragmentType": "ParticipantsTable_user";
};
export type ParticipantsTable_user$key = {
  readonly " $data"?: ParticipantsTable_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ParticipantsTable_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ParticipantsTable_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AlertVoxpopmeVideoAnalysis_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ParticipantBatchActions_user"
    }
  ],
  "type": "UserNode",
  "abstractKey": null
};

(node as any).hash = "c4f771cb99119166e3405c145cc63e60";

export default node;
